import { render, staticRenderFns } from "./CollectorInstallPanel.vue?vue&type=template&id=223fc66a&scoped=true"
import script from "./CollectorInstallPanel.vue?vue&type=script&lang=js"
export * from "./CollectorInstallPanel.vue?vue&type=script&lang=js"
import style0 from "./CollectorInstallPanel.vue?vue&type=style&index=0&id=223fc66a&scoped=true&lang=css"
import style1 from "./CollectorInstallPanel.vue?vue&type=style&index=1&id=223fc66a&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "223fc66a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/disk1/buildAgent/work/ffa2b6072150c7f8/vAnalyticsJS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('223fc66a')) {
      api.createRecord('223fc66a', component.options)
    } else {
      api.reload('223fc66a', component.options)
    }
    module.hot.accept("./CollectorInstallPanel.vue?vue&type=template&id=223fc66a&scoped=true", function () {
      api.rerender('223fc66a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/modules/admin/components/Collector/CollectorInstallPanel.vue"
export default component.exports